"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function start() {
    return __awaiter(this, void 0, void 0, function* () {
        const div = document.createElement("div");
        div.style.position = "absolute";
        div.style.top = "0px";
        div.style.left = "0px";
        div.style.backgroundColor = "silver";
        div.style.width = "100vw";
        div.style.padding = "5px";
        div.style.margin = "0px";
        div.style.opacity = ".8";
        div.style.cursor = "pointer";
        div.addEventListener("mousedown", () => document.body.removeChild(div));
        div.innerText = "❌ hello world";
        document.body.appendChild(div);
    });
}
document.addEventListener('DOMContentLoaded', () => {
    start();
});
